export default {"src":"/_next/static/media/select-bar-checkmark-active.component.04f3fb61.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};